$(document).ready(function() {
    oclayerednavigationajax.productViewChange();
});

var oclayerednavigationajax = {

    /* Use again and update ajaxComplete from common.js */
    'productViewChange' : function() {
    // Product List
      $('#list-view').click(function() {
        $('#content .product-grid > .clearfix').remove();

        $('#content  .product-grid').attr('class', 'product-layout product-list col-xs-12');

        $('.product-list .product-thumb .image').addClass("col-md-4 col-sm-4 col-xs-12");
        $('.product-list .product-thumb .caption').addClass("col-md-8 col-sm-8 col-xs-12");

        localStorage.setItem('display', 'list');
                $('.btn-group').find('#list-view').addClass('selected');
                $('.btn-group').find('#grid-view').removeClass('selected');
      });

      // Product Grid
      $('#grid-view').click(function() {
        // What a shame bootstrap does not take into account dynamically loaded columns
        var cols = $('#column-right, #column-left').length;

        if (cols == 2) {
          $('#content .product-list').attr('class', 'product-layout product-grid col-lg-6 col-md-6 col-sm-12 col-xs-12');
        } else if (cols == 1) {
          $('#content .product-list').attr('class', 'product-layout product-grid col-lg-4 col-md-4 col-sm-6 col-xs-12');
        } else {
          $('#content .product-list').attr('class', 'product-layout product-grid col-lg-4 col-md-4 col-sm-6 col-xs-12');
        }

        localStorage.setItem('display', 'grid');
                $('.product-grid .product-thumb ').find('.image').removeClass("col-md-4 col-sm-4 col-xs-12");
                $('.product-grid .product-thumb ').find('.caption').removeClass("col-md-8 col-sm-8 col-xs-12");
                $('.btn-group').find('#grid-view').addClass('selected');
                $('.btn-group').find('#list-view').removeClass('selected');
      });

      if (localStorage.getItem('display') == 'list') {
        $('#list-view').trigger('click');
      } else {
        $('#grid-view').trigger('click');
      }
    }

};